import { ROUTES } from '@/constants/routeConstants'
import { useAuthStore } from '@/store/auth'
import { Navigate } from '@tanstack/react-router'

export const RequireSignedOut = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const user = useAuthStore((s) => s.user)

  if (user) {
    return <Navigate to={ROUTES.API_KEYS} replace={true} />
  }

  return children
}
